import styled from "styled-components";
import { devices } from "../../../Devices";

export const HomeLatestThemesPreviewContainer = styled.section`
  margin-top: 1.6rem;
  margin-bottom: 1.6rem;
  border-radius: 1.6rem;
  padding: 1rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    margin-top: 0;
    text-transform: uppercase;
  }

  @media ${devices.mobileL} {
    padding: 0;
  }
`;

export const ThemesPreviewContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(6, min-content);
  justify-content: center;
  gap: 2rem;
  width: 100%;
  margin-top: 1.2rem;

  @media ${devices.laptop} {
    gap: 2.2rem;
  }
  @media ${devices.tablet} {
    grid-template-columns: repeat(5, min-content);
    gap: 1rem;
  }
  @media ${devices.mobileL} {
    grid-template-columns: repeat(4, min-content);
    gap: 0.6rem;
    justify-content: space-around;
  }
`;

export const CardAndButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
  border-radius: 1rem;
  box-shadow: 0 4px 20px rgba(174, 95, 5, 0.13);
  padding: 1rem;

  @media ${devices.mobileL} {
    button {
      font-size: 1rem;
      font-weight: 600;
    }
  }

  .theme-preview-card {
    @media ${devices.tablet} {
      width: 12rem;
      height: 14.46rem;
    }
    @media ${devices.mobileL} {
      width: 9rem;
      height: 10.85rem;

      &::after {
        font-size: 0.8rem;
        padding: 0.5rem 0;
      }
    }
  }
`;
